/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { ConfigProvider, Table } from "antd";

const Datatable = ({ props, columns, dataSource, loading }) => {
  const [searchText, setSearchText] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filteredDataSource, setFilteredDataSource] = useState(
    Array.isArray(dataSource) ? dataSource : []
  );
  const [isRtl, setIsRtl] = useState(false);

  const detectRtl = () => {
    if (typeof window === "undefined") return false;
    const lang = (localStorage.getItem("lang") || "en").toLowerCase();
    const htmlDir = document?.documentElement?.getAttribute("dir");
    const bodyClass = document?.body?.className || "";
    const rtlSetting = (localStorage.getItem("rtl") || "").toLowerCase();
    return (
      lang.startsWith("ar") ||
      htmlDir === "rtl" ||
      bodyClass.includes("layout-mode-rtl") ||
      rtlSetting.includes("rtl")
    );
  };

  useEffect(() => {
    const syncDirection = () => setIsRtl(detectRtl());
    syncDirection();
    window.addEventListener("languageChanged", syncDirection);
    window.addEventListener("storage", syncDirection);
    return () => {
      window.removeEventListener("languageChanged", syncDirection);
      window.removeEventListener("storage", syncDirection);
    };
  }, []);

  useEffect(() => {
    const source = Array.isArray(dataSource) ? dataSource : [];
    if (!searchText.trim()) {
      setFilteredDataSource(source);
      return;
    }

    const lowered = searchText.toLowerCase();
    setFilteredDataSource(
      source.filter((record) =>
        Object.values(record || {}).some((field) =>
          String(field).toLowerCase().includes(lowered)
        )
      )
    );
  }, [dataSource, searchText]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const source = Array.isArray(dataSource) ? dataSource : [];
    const filteredData = source.filter((record) =>
      Object.values(record || {}).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredDataSource(filteredData);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const paginationItemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <span aria-label="Previous">
          <i className={`fa ${isRtl ? "fa-angle-right" : "fa-angle-left"}`} />
        </span>
      );
    }
    if (type === "next") {
      return (
        <span aria-label="Next">
          <i className={`fa ${isRtl ? "fa-angle-left" : "fa-angle-right"}`} />
        </span>
      );
    }
    return originalElement;
  };

  return (
    <>
      <div className="search-set table-search-set">
  <div className="search-input">
    <a href="#" className="btn btn-searchset">
      <i className="ti ti-search fs-14 feather-search" />
    </a>
    <div id="DataTables_Table_0_filter" className="dataTables_filter">
      <label>
        {" "}
        <input
          type="search"
          onChange={(e) => handleSearch(e.target.value)}
          className="form-control form-control-sm"
          placeholder="Search"
          aria-controls="DataTables_Table_0"
        />
      </label>
    </div>
  </div>
</div>


      <ConfigProvider direction={isRtl ? "rtl" : "ltr"}>
        <Table
          key={props}
          className="table datanew dataTable no-footer"
          rowSelection={rowSelection}
          columns={columns}
          dataSource={filteredDataSource}
          loading={loading}
          rowKey={(record) => record?.id || record?.key || record?._id}
          pagination={{
            locale: { items_per_page: "" },
            itemRender: paginationItemRender,
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30"],
          }}
        />
      </ConfigProvider>
        </>
  );
};

export default Datatable;
